<template>
    <div>
        <f-read-only-field
            v-if   = "readonly"
            class  = "w-100"
            :dense = "true"
            :label = "label"
            :value = "moneyAsString(currency)"
            color  = "pt-0-5 pl-1 ro-background"
        />

        <f-currency-field
            v-if          = "!readonly"
            class         = "money"
            :label        = "label"
            :readonly     = "readonly"
            v-model       = "currency"
            :hide-details = "true"
            @input        = "onInput"
        />
    </div>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import FCurrencyField from "@/modules/core/components/utils/FCurrencyField.vue";

export default {
    name: "FCurrencyFieldRw",

    components: {
        FCurrencyField,
        FReadOnlyField
    },

    props: {
        label: {
        },

        value: {

        },

        readonly: {
            required: false,
            default: function () {
                return false;
            }
        },

        hideDetails: {
            required: false,
            default: function () {
                return false;
            }
        },
    },

    data: () => ({
        currency: null,
    }),

    mounted() {
        this.currency = this.value;
    },

    watch: {
        value () {
            this.currency = this.value;
        }
    },

    methods: {
        onInput () {
            this.$emit("input", this.currency)
        },

        moneyAsString (value) {
            return Core.format.money(value);
        }
    }
}
</script>

<style scoped>

</style>